import React from 'react'
import { Modal, List, Typography, theme } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import type { FlattenedRateData } from './types'

const { Text } = Typography

type UnsavedRatesModalProps = {
  open: boolean
  unsavedRates: FlattenedRateData[]
  onClose: () => void
}

const UnsavedRatesModal: React.FC<UnsavedRatesModalProps> = ({ open, unsavedRates, onClose }) => {
  const { token } = theme.useToken()

  return (
    <Modal
      open={open}
      title={
        <span>
          <ExclamationCircleOutlined style={{ color: token.colorWarning, marginRight: 8 }} />
          Cannot Enter Sort Mode
        </span>
      }
      onCancel={onClose}
      footer={null}
      width={480}
    >
      <Text>
        The following rate(s) have not been saved to the system yet and cannot be included in sort
        order. Please save them first before sorting.
      </Text>
      <List
        style={{ marginTop: 16 }}
        bordered
        size="small"
        dataSource={unsavedRates}
        renderItem={(rate) => (
          <List.Item>
            <Text strong style={{ color: token.colorPrimary, marginRight: 8 }}>
              {rate.rate_code}
            </Text>
            <Text type="secondary">{rate.display_name || rate.name || '—'}</Text>
          </List.Item>
        )}
      />
    </Modal>
  )
}

export default UnsavedRatesModal
